import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, ClickAwayListener } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useBoolean } from './use-boolean';
import { RHFTextField } from '.';
import { CustomCountryListPopover } from './customCountryPopover';

export default function RHFPhoneField({ countryCode, setCountryCode, name, type, required, ...other }) {
  const isOpenCountryCode = useBoolean(false);

  const onClickCountry = (value) => {
    isOpenCountryCode.onFalse();
    setCountryCode(value);
  };

  return (
    <Stack direction="row" spacing={1} width="100%">
      {/* Country code pill */}
      <ClickAwayListener onClickAway={isOpenCountryCode.onFalse}>
        <Box sx={{ position: 'relative' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            onClick={isOpenCountryCode.onToggle} // ✅ toggle here
            role="button"
            aria-expanded={isOpenCountryCode.value}
            tabIndex={0}
            sx={{
              minWidth: 66,
              px: 1,
              border: '1px solid #E0E3E7',
              borderRadius: '10px',
              bgcolor: '#fff',
              cursor: 'pointer',
              userSelect: 'none',
              height: 42, // match TextField (size="small")
            }}
          >
            <Typography color="text.secondary" fontSize={15} sx={{ mr: 0.5 }}>
              {/* {countryCode} */}
              {`+${countryCode}`}
            </Typography>
            {isOpenCountryCode.value ? (
              <KeyboardArrowUpIcon fontSize="small" />
            ) : (
              <KeyboardArrowDownIcon fontSize="small" />
            )}
          </Stack>

          {isOpenCountryCode.value && (
            <Box
              sx={{
                position: 'absolute',
                top: 'calc(100% + 8px)',
                left: 0,
                zIndex: 1300,
                bgcolor: '#fff',
                border: '1px solid #eeeeee',
                borderRadius: 1,
                boxShadow: 3,
                minWidth: 220,
              }}
            >
              <CustomCountryListPopover
                isOpenCountryCode={isOpenCountryCode}
                onClickCountry={onClickCountry}
                countryCode={countryCode}
              />
            </Box>
          )}
        </Box>
      </ClickAwayListener>

      {/* Phone input */}
      <RHFTextField
        name={name || 'phone'}
        placeholder="Enter Phone Number"
        type={type || 'text'}
        size="small"
        required={required}
        className="custom-inspection-textfield"
        InputLabelProps={{ shrink: false }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
          },
          '& .MuiOutlinedInput-root fieldset': {
            borderColor: '#E0E3E7',
          },
          '& .MuiOutlinedInput-root:hover fieldset': {
            borderColor: '#B2BAC2',
          },
          '& .MuiOutlinedInput-root.Mui-focused fieldset': {
            borderColor: '#6F7E8C',
          },
          '& .MuiInputBase-input': {
            padding: '8px 12px', // small size friendly
            fontSize: '16px',
            '::placeholder': { color: '#9AA0A6', opacity: 1 },
          },
          height: 40, // match country pill height
        }}
        {...other}
      />
    </Stack>
  );
}

RHFPhoneField.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.any,
  isFiledErrored: PropTypes.bool,
  countryCode: PropTypes.any,
  setCountryCode: PropTypes.any,
};
